<template>
  <div class="timeplan">
    <enfold-uc>
      <template slot="up">
        <div class="titd">
          <span class="tit">{{ $t('schedule.playPlan') }}</span>
          <span class="tit" style="color: #000;font-family:normal;letter-spacing:0px">({{ $t('nswce10') }})</span>
        </div>
      </template>
      <template slot="center">
        <div class="timescroll">
          <template v-if="tl === 0">
            <template v-if="$pstore.state.finaldata.length != 0">
              <template v-if="!$pstore.state.finaldata[$pstore.state.currentindex].isDefault">
                <time-plan-items v-for="(item, index) in $pstore.state.finaldata[$pstore.state.currentindex].step"
                  :key="index" :index="index"></time-plan-items>
                <div class="addplan" @click="addPlanStep()">
                  <!-- <div class="addp img"><img src="~@/assets/images/public/public_add.png" /></div> -->
                  <div class="addpimg">
                    <!-- <img src="~@/assets/images/public/public_add.png" /> -->
                  </div>
                  <div class="addptxt">{{ $t('schedule.addPlayStep') }}</div>
                </div>
              </template>
              <div v-else class="flex-a-c" style="height: 100%;">
                <div class="flex-d-a-c">
                  <p style="margin: 16px 0px;"> {{ $t('nswce04') }}</p>
                  <p> {{ $t('nswce05') }}</p>
                </div>
              </div>
            </template>
          </template>
          <template v-if="tl === 1">
            <timer-shaft :timeInfo="timeInfoFormatting($pstore.state.finaldata)"></timer-shaft>
          </template>
        </div>

        <!-- <template v-if="$pstore.state.finaldata.length != 0">
          <div class="button">
            <div class="control fabu" @click="publish()">{{ $t('schedule.publish') }}</div>
            <div class="control white" @click="cancel()">{{ $t('terminal.cancel') }}</div>
          </div>
        </template> -->

        <template v-if="$pstore.state.finaldata.length != 0">
          <div class="button">
            <el-button type="primary" round @click="publish()"
              :disabled="$pstore.state.finaldata.filter(p => p.isDefault == 0).length == 0">
              <div style="font-size: 24px;">{{ $t('schedule.publish') }}</div>
            </el-button>
            <el-button round @click="cancel()">
              <div style="font-size: 24px; color: var(--theme-color-customized-1);">{{ $t('terminal.cancel') }}</div>
            </el-button>
          </div>
        </template>

      </template>
    </enfold-uc>
    <!-- <get-device-dialog :deviceDialogVisible="deviceDialogVisible" @changeShow="showAdd" :play_mode="2">
		</get-device-dialog> -->
    <terminal-list :terminalListDV="deviceDialogVisible" @publishTerminal="publishTerminal" :append="true"
      :diffIsAppend="1" :defaultPName="`${$t('schedule.timimgPlan')}-${new Date().getTime()}`">
    </terminal-list>
  </div>
</template>
<!-- 定时播放 -->
<script>
import TimePlanItems from "./items/TimePlanItems.vue"
import TimerShaft from "./items/TimerShaft.vue"
//import GetDeviceDialog from "./GetDeviceDialog.vue"
import EnfoldUc from "@/components/basics/EnfoldUC"
import TerminalList from '@/components/schedule/windows/children/TerminalList'
import { groupByTerminal } from "@/assets/scripts/publicFunction.js";
import groupIdInfo from "@/assets/scripts/groupIdInfo.js";

const newDate = new Date();
const dateInfo = {
  year: newDate.getFullYear(),
  month: newDate.getMonth(),
  day: newDate.getDate()
};
export default {
  name: "TimePlan",
  props: {
    tl: {
      type: Number,
    }
  },
  components: {
    TimePlanItems,
    //GetDeviceDialog,
    TerminalList,
    EnfoldUc,
    TimerShaft
  },
  data() {
    return {
      deviceDialogVisible: false,
      isDate: false,
      stardate: '',
      finishdate: '',
      plantime: [new Date(dateInfo.year, dateInfo.month, dateInfo.day, 0, 0), new Date(dateInfo.year, dateInfo
        .month, dateInfo.day, 23, 59, 59)],
      plandate: [],
      weeks: [{
        name: '日',
        value: 0
      }, {
        name: '一',
        value: 0
      }, {
        name: '二',
        value: 0
      }, {
        name: '三',
        value: 0
      }, {
        name: '四',
        value: 0
      }, {
        name: '五',
        value: 0
      }, {
        name: '六',
        value: 0
      }],
      allactive: false
    }
  },
  // watch: {
  //   '$pstore.state.finaldata': {
  //     handler(nVal) {
  //       console.log(nVal);
  //     }
  //   }
  // },
  methods: {
    timeInfoFormatting(val) {
      let timerShaft = val.map((item) => {
        const { name, step } = item;
        return {
          name: name,
          schedule: step.map((s) => {
            // Math.pow(2, 0)
            const { dateEnd, dateStart, endTime, startTime, isDateLimit, validWeek } = s;
            let weekValue = 0;
            validWeek.forEach((week, index) => {
              const { value } = week;
              value && (weekValue += Math.pow(2, index));
            });
            return isDateLimit ? { dateEnd: new Date(dateEnd), dateStart: new Date(dateStart), endTime, startTime, weekValue } : { endTime, startTime, weekValue }
          })
        }
      });
      return timerShaft;
    },
    showAdd(data) {
      if (data === 'false') {
        this.deviceDialogVisible = false;
      } else {
        this.deviceDialogVisible = true;
      }
    },
    change_allactive() {
      this.allactive = !this.allactive;
      for (let i = 0; i < this.weeks.length; i++) {
        if (this.allactive == 1) {
          this.weeks[i].value = 1;
        } else if (this.allactive == 0) {
          this.weeks[i].value = 0;
        }
      }
    },
    publishTerminal(terminalList, adapter_screen, isAppend, publishName) {

      if (terminalList && terminalList.length > 0) {

        const group_id = this.$cookies.get("group_id");
        this.$pstore.commit('publish', [terminalList, adapter_screen, isAppend, 2, group_id]);

        let listGroup = groupByTerminal(terminalList, "main_device").map((group) => {
          const { list, main_device } = group;
          return { main_device, ids: list.map((d) => d.id) };
        });

        const { group_id: p_group_id, play_ids, play_mode, publish_strategy, publish_type, isAppend: p_isAppend, adapter_screen: p_adapter_screen, playSchedule } = this.$pstore.state.publishData;

        const gInfo = groupIdInfo(p_group_id);
        let isCheck = false;
        if (gInfo) {
          const { check_state } = gInfo;
          isCheck = (check_state & 1);
        }

        this.$http.post("/admin/publish/addNew", {
          group_id: p_group_id,
          play_ids: play_ids,
          list_group: encodeURIComponent(JSON.stringify(listGroup)),
          play_mode: play_mode,
          publish_strategy: publish_strategy,
          publish_type: publish_type,
          isAppend: p_isAppend,
          adapter_screen: p_adapter_screen,
          playSchedule: encodeURIComponent(JSON.stringify(playSchedule)),
          is_drafts: 0,
          publish_name: publishName
        }, () => {
          this.$http.post("/admin/Command/getDownloadList", {}, (res) => {
            this.$store.commit("ISSUE_LIST", res);
            !isCheck && this.$bus.$emit('publish-event', "open-download");
          });
        });


        // this.$router.push({ name: 'IssueManage' });
        if (isCheck) {
          this.$msg({ message: this.$t('cspm11'), type: 'warning', });
        } else {
          this.$msg({ message: this.$t('cspm10'), type: 'success', });
        }
        this.$router.push({
          path: '/advancedRelease/issueManage'
        })
        // this.$router.go(0);

        // let listGroup = groupByTerminal(terminalList, "main_device")
        // const group_id = this.$cookies.get("group_id");
        // this.$pstore.commit('publish', [terminalList, adapter_screen, isAppend, 2, group_id]);
        // listGroup.forEach(ele =>{
        // 	let idList = [];
        // 	ele.list.forEach(val=>{
        // 		idList.push(val.id)
        // 	})
        // 	this.$http.post("/admin/publish/add", {
        // 		group_id: this.$pstore.state.publishData.group_id,
        // 		play_ids: this.$pstore.state.publishData.play_ids,
        // 		device_ids: idList.toString(),
        // 		play_mode: this.$pstore.state.publishData.play_mode,
        // 		publish_strategy: this.$pstore.state.publishData.publish_strategy,
        // 		main_device:ele.main_device,
        // 		publish_type: this.$pstore.state.publishData.publish_type,
        // 		isAppend: this.$pstore.state.publishData.isAppend,
        // 		adapter_screen: this.$pstore.state.publishData.adapter_screen,
        // 		playSchedule: encodeURIComponent(JSON.stringify(this.$pstore.state.publishData
        // 			.playSchedule)),
        // 		is_drafts: 0
        // 	}, data => {
        // 		console.log(data)
        // 		this.$http.post("/admin/Command/getDownloadList", {}, data => {
        // 			this.$store.commit("ISSUE_LIST", data);
        // 		});
        // 		this.$msg({
        // 			message: '发布成功',
        // 			type: 'success',
        // 		});
        // 		this.$router.push({
        // 			name: 'IssueManage'
        // 		})
        // 	})
        // })
        // this.$http.post("/admin/publish/add", {
        // 	group_id: this.$pstore.state.publishData.group_id,
        // 	play_ids: this.$pstore.state.publishData.play_ids,
        // 	device_ids: this.$pstore.state.publishData.deviceids,
        // 	play_mode: this.$pstore.state.publishData.play_mode,
        // 	publish_strategy: this.$pstore.state.publishData.publish_strategy,
        // 	publish_type: this.$pstore.state.publishData.publish_type,
        // 	isAppend: this.$pstore.state.publishData.isAppend,
        // 	adapter_screen: this.$pstore.state.publishData.adapter_screen,
        // 	playSchedule: encodeURIComponent(JSON.stringify(this.$pstore.state.publishData
        // 		.playSchedule)),
        // 	is_drafts: 0
        // }, data => {
        // 	console.log(data)
        // 	this.$http.post("/admin/Command/getDownloadList", {}, data => {
        // 		this.$store.commit("ISSUE_LIST", data);
        // 	});
        // 	this.$msg({
        // 		message: '发布成功',
        // 		type: 'success',
        // 	});
        // 	this.$router.push({
        // 		name: 'IssueManage'
        // 	})
        // })
        //console.log('terminalList',terminalList);
        //console.log('adapter_screen',adapter_screen);
        //console.log('isAppend',isAppend);
      }


      this.deviceDialogVisible = false;
    },
    selectWeek(index) {
      this.weeks[index].value = !this.weeks[index].value;
    },
    addPlanStep() {
      this.$pstore.commit('addPlanStep')
    },
    publish() {
      this.deviceDialogVisible = true;
      //this.$pstore.commit('publish');
    },
    savePlanDate() {
      this.$pstore.commit('savePlanDate')
    },
    cancel() {
      this.$router.push({
        path: 'IssueManage'
      })
      //this.$pstore.commit('clearitems')
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-height: 625px) {
  /deep/ .el-input__inner {
    height: 25px;
  }

  .addptxt {
    font-size: 12px;
    font-weight: normal;
  }
}

.active {
  background-color: #0184bb;
}

span {
  font-family: PingFang-SC-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3px;
  letter-spacing: 3px;
  color: #617883;
}

.close {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  background-color: red;
}

.timeplan {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: white;
}

.timescroll {
  height: 83%;
  overflow-y: auto;
  overflow-x: hidden;
}

.titd {
  height: 100%;
  width: 100%;
}

.titd::before {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}

.tit {
  font-family: PingFang-SC-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3px;
  height: 16px;
  letter-spacing: 3px;
  color: #617883;
  padding-left: 2%;
}

.no {
  width: 40px;
  height: 20px;
  // background-image: linear-gradient(270deg,
  //     #86eae7 0%,
  //     #4cccf0 45%,
  //     #11adf8 100%),
  //   linear-gradient(#35cafa, #35cafa);
  // background-blend-mode: normal, normal;
  background-color: var(--theme-color-customized-1);
  border-radius: 0px 20px 20px 0px;
  text-align: center;
  color: #ffffff;
}

.time {
  display: flex;
  align-items: center;
  padding-left: 1%;
}

.time span {
  display: block;
}

.tt {
  width: 75%;
  display: flex;
  align-items: center;
}

.time el-input {
  width: 20%;
}

// .items {
// 	/* width: 95%;
// 	height: 35%;
// 	margin: 1% auto;
// 	border: 1px solid #cfd5d8;
// 	display: flex;
// 	border-radius: 10px;
// 	flex-direction: column;
// 	position: relative; */
// 	/* border: 1px solid black; */
// }

.cd {
  flex-basis: 25%;
  /* border: 1px solid black; */
}

.top {
  display: flex;
  align-items: center;
}

.time {
  flex-basis: 51%;
}

.count {
  display: flex;
  align-items: center;
}

.count span {
  margin-left: 1%;
}

.count div {
  flex-basis: 38%;
  margin-left: 1%;
}

.count el-col {
  padding-left: 1%;
}

.date {
  display: flex;
  align-items: center;
}

.cbox {
  flex-basis: 15%;
  margin-left: 1%;
}

.cdate {
  flex-basis: 38%;
  display: flex;
  align-items: center;
}

.week {
  display: flex;
  width: 100%;
  align-items: center;
}

.weeks {
  width: 68%;
  display: flex;
  justify-content: space-around;
}

.weeks li {
  display: block;
  padding: 1%;
  border-radius: 4px;
  border: solid 1px #cfd5d8;
}

.addplan {
  border-radius: 10px;
  border: solid 1px #cfd5d8;
  width: 95%;
  height: 11%;
  min-height: 45px;
  margin: 1% auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;

  font-family: PingFang-SC-Regular;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 0px;
  color: var(--theme-color-customized-1);
}

.addplan:hover {
  cursor: pointer;
}

.addpimg {
  flex-basis: 50%;
  margin: 0 auto;
  width: 4.7%;
  /* border: 1px solid black; */
  background-image: url(~@/assets/images/public/public_add.png);
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.addpimg img {
  height: 2.5vw;
  width: 2.5vw;
}

.addpimgtxt {
  flex-basis: 25%;
}

.button {
  /* margin: 0 auto;
		margin-bottom: 0; */
  position: absolute;
  left: 50%;
  bottom: 4%;
  transform: translate(-50%);
  width: 44%;
  height: 6%;
  min-width: 380px;
  min-height: 35px;
  display: flex;
  justify-content: space-between;
}

.control:hover {
  cursor: pointer;
}

.control {
  width: 40%;
  text-align: center;
  align-items: center;
  border-radius: 40px;
}

.control::before {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}

.fabu {
  // background-image: linear-gradient(270deg,
  //     #86eae7 0%,
  //     #4cccf0 45%,
  //     #11adf8 100%),
  //   linear-gradient(#dddddd, #dddddd);
  // background-blend-mode: normal, normal;
  background-color: var(--theme-color-customized-1);
  border-radius: 40px;
  font-family: PingFang-SC-Regular;
  font-size: 24px;
  font-stretch: normal;
  line-height: 38px;
  letter-spacing: 0px;
  color: #ffffff;
}

.white {
  border-radius: 40px;
  border-style: solid;
  font-size: 24px;
  border-width: 1px;
  font-family: PingFang-SC-Regular;
  border-image-slice: 1;
  color: var(--theme-color-customized-1);
}
</style>
